import React, { FC, memo } from 'react';
import { Greeting, Heading, Paragraph, UserName } from './styles';
import { Props } from './types';

const Intro: FC<Props> = ({ periodLabel, firstName }) => (
  <header>
    <Heading>Your {periodLabel} SWD community summary</Heading>
    <Paragraph>
      <Greeting>
        Hi <UserName>{firstName}</UserName>,
      </Greeting>
      Here’s a snapshot of what you’ve been up to this month—and the great
      things happening around you in the SWD community.
    </Paragraph>
  </header>
);

export default memo(Intro);
